const form = document.querySelector(".calcForm");
const aside = document.querySelector(".calculatorResults");
const formBtn = document.querySelector(".calcSubmit");
const maintenance = document.querySelector(".calcResultsHead");
const BMR = document.querySelector("#BMR");
const ABA = document.querySelector("#ABA");
const TEF = document.querySelector("#TEF");
const EXE = document.querySelector("#EXE");
const finalTally = document.querySelector(".finalTally");
  const warning = document.querySelector(".warning");

let previousFormData = {};

formBtn.addEventListener("click", (e) => {
  e.preventDefault();
  const formData = {
    age: form.querySelector("#age").value,
    feet: form.querySelector("#feet").value,
    inches: form.querySelector("#inches").value,
    weight: form.querySelector("#weight").value,
    gender: form.querySelector("#gender").value,
    act: form.querySelector("#activity").value,
  };

  // Check if the form data has changed
  if (JSON.stringify(formData) === JSON.stringify(previousFormData)) {
    console.log("Data has not changed.");
    return; // Exit early if data hasn't changed
  }

  if(formData.weight < 1){
    showWarning("Enter a weight above 0")
    return;
  }
  if(formData.feet < 1 || formData.feet < 0){
    showWarning("Enter a valid height")
    return;
  }
  if(formData.inches < 0){
    showWarning("Enter a valid height")
    return;
  }
  if(formData.age < 1 || formData.age > 100){
    showWarning("Enter a valid age")
    return;
  }
  hideWarning()
  

  // Update the previous form data
  previousFormData = { ...formData };

  const TDEE = calculateTDEE(
    Number(formData.age),
    heightToInches(formData.feet, formData.inches),
    Number(formData.weight),
    formData.gender
  );
  const ABAValue = TDEE * 0.1875;
  const TEFValue = TDEE * 0.075;
  const exFactor = 0.7;
  const finalMaintenance =
    (TDEE* ((1.0 + exFactor) - (exFactor * (((4 - formData.act) + 0.01) / 4)))) + ABAValue + TEFValue ;
  const exerciseAdded = (TDEE* ((1.0 + exFactor) - (exFactor * ((4 - formData.act)  / 4)))) - TDEE;
  BMR.querySelector("span").innerHTML = Math.trunc(TDEE);
  ABA.querySelector("span").innerHTML = Math.trunc(ABAValue);
  TEF.querySelector("span").innerHTML = Math.trunc(TEFValue);
  EXE.querySelector("span").innerHTML = Math.trunc(exerciseAdded);
  finalTally.querySelector("u").innerHTML = Math.trunc(finalMaintenance);
  maintenance.querySelector("span").innerHTML = Math.trunc(finalMaintenance);

  aside.classList.add("active");
});

function heightToInches(feet, inches) {
  return Number(feet) * 12 + Number(inches);
}
function lbsToKg(pounds) {
  return pounds * 0.453592;
}

function inchesToCm(inches) {
  return inches * 2.54;
}
function calculateTDEE(age, heightInInches, weightInLbs, gender) {
  let weightInKg = lbsToKg(weightInLbs);

  let heightInCm = inchesToCm(heightInInches);

  let tdee;
  if (gender === "male") {
    tdee = 10 * weightInKg + 6.25 * heightInCm - 5 * age + 5;
  } else {
    tdee = 10 * weightInKg + 6.25 * heightInCm - 5 * age - 161;
  }
  return tdee;
}
function showWarning(message){
  warning.innerHTML = message;
  warning.style.display = "block";
}
function hideWarning(){
  warning.style.display = "none";
}